import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@robocorp/components';
import { useSelector, useIsSSO } from '~/hooks';

type UserSsoRestriction = 'isSsoAdmin';

interface Props {
  permission: UserSsoRestriction;
  children: ReactNode;
  displayErrorOnMissingRights?: true;
}

export const CurrentSsoRestriction: FC<Props> = ({
  children,
  permission,
  displayErrorOnMissingRights,
}) => {
  const { isSSO } = useIsSSO();
  const { t } = useTranslation();

  const currentUser = useSelector(({ userResources }) => userResources.users.current);
  const hasAccess =
    permission === 'isSsoAdmin' && isSSO && currentUser.sso_context.realmAdmin === true;

  if (hasAccess) {
    return <>{children}</>;
  }

  if (displayErrorOnMissingRights) {
    return (
      <Box alignItems="center" height="100%" width="100%" justifyContent="Center" display="flex">
        <Box maxWidth={480}>
          <Typography as="h3" mb={8}>
            {t('ssoManagement.missingPermission')}
          </Typography>
          <Typography lineHeight={1.6}>{t('ssoManagement.missingPermissionCTA')}</Typography>
        </Box>
      </Box>
    );
  }

  return null;
};
